import { render, staticRenderFns } from "./ExchangeAndReturn.vue?vue&type=template&id=c36fc682&scoped=true&"
import script from "./ExchangeAndReturn.vue?vue&type=script&lang=js&"
export * from "./ExchangeAndReturn.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeAndReturn.vue?vue&type=style&index=0&id=c36fc682&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36fc682",
  null
  
)

export default component.exports